// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ScheduleDate\ApiScheduleDateSelf.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { CoordinationCardVersion, CoordinationCardVersionData, CoordinationCardVersionOptions } from 'data/models/CoordinationCardVersion';
import { ScheduleDateEntity, ScheduleDateEntityData, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';
import { ScheduleDateVersion, ScheduleDateVersionData, ScheduleDateVersionOptions } from 'data/models/ScheduleDateVersion';

// ScheduleDateSelfData is the class that ScheduleDateSelf serializes to/from
export interface ScheduleDateSelfData {
    Id : number;
	
    CoordinationCardVersions : CoordinationCardVersionData[] | null;
    DeletedCoordinationCardVersions : CoordinationCardVersionData[] | null;
    Live : ScheduleDateEntityData | null;
    Versions : ScheduleDateVersionData[] | null;
	
}

// ScheduleDateSelfOptions is the class which may be passed to the ScheduleDateSelf constructor to define optional initial data values
export interface ScheduleDateSelfOptions {
    Id : number;
	
    CoordinationCardVersions? : CoordinationCardVersionOptions[] | null;
    DeletedCoordinationCardVersions? : CoordinationCardVersionOptions[] | null;
    Live? : ScheduleDateEntityOptions | null;
    Versions? : ScheduleDateVersionOptions[] | null;
	
}

export class ScheduleDateSelf {
    public Id : DataSignal<number>;
	
    public CoordinationCardVersions : SDataArray<CoordinationCardVersion>;
    public DeletedCoordinationCardVersions : SDataArray<CoordinationCardVersion>;
    public Live : DataSignal<ScheduleDateEntity | null>;
    public Versions : SDataArray<ScheduleDateVersion>;
	

    constructor();
    constructor(data : ScheduleDateSelfOptions);
    constructor(data: ScheduleDateSelfOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.CoordinationCardVersions = SArray<CoordinationCardVersion>([]);
        this.DeletedCoordinationCardVersions = SArray<CoordinationCardVersion>([]);
        this.Live = S.value<ScheduleDateEntity | null>(null);
        this.Versions = SArray<ScheduleDateVersion>([]);
	    
    }

    static key(obj : ScheduleDateSelf) {
        return obj.Id();
    }
    
    static dataKey(obj : ScheduleDateSelfOptions) {
        return obj.Id;
    }

    static update(obj : ScheduleDateSelf, data : ScheduleDateSelfOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ScheduleDateSelf.ts